import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=11b72560"
import script from "./channels.vue?vue&type=script&lang=js"
export * from "./channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports